import { useEffectOnce } from "../hooks/useEffectOnce";
import { useState, FC, useRef } from "react";
import { t } from "i18next";

interface Props {
  showModal: boolean;
  url: string;
  title: string;
  onClose: () => void;
}

const Modal: FC<Props> = ({ showModal, onClose, url, title }) => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<unknown>(null);
  const bodyRef = useRef<HTMLDivElement>(null);

  useEffectOnce(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(url);
        const data = await response.json();
        const {
          content: { rendered },
        } = data;
        setData(rendered);

        setTimeout(() => {
          // clone all important elements
          const topSectionElements = bodyRef.current?.querySelectorAll(
            "section:first-of-type .elementor-widget-container"
          );

          const clonedElements: any[] = [];
          topSectionElements?.forEach((element) => {
            const clonedElement = element.cloneNode(true);
            (clonedElement as HTMLElement).querySelector("style")?.remove();
            if ((clonedElement as HTMLElement).querySelector("img")) {
              const img = (clonedElement as HTMLElement).querySelector("img");
              //
              img?.setAttribute(
                "src",
                img
                  .getAttribute("src")
                  ?.replace(new RegExp(/(http:\/\/)/, "g"), "https://") || ""
              );
              img?.setAttribute(
                "data-src",
                img
                  .getAttribute("data-src")
                  ?.replace(new RegExp(/(http:\/\/)/, "g"), "https://") || ""
              );
              img?.setAttribute(
                "data-srcset",
                img
                  .getAttribute("data-srcset")
                  ?.replace(new RegExp(/(http:\/\/)/, "g"), "https://") || ""
              );
            }
            clonedElements.push(clonedElement);
          });

          // fix the numerological number spacing
          clonedElements[2]
            .querySelector("p")
            .setAttribute("class", "not-prose my-0");

          const container = document.createElement("div");
          const htmlContent = `
            <div class="flex flex-col">
              <div class="flex items-center">
                <div>
                  ${clonedElements[0].innerHTML}
                </div>
                <div class="pr-6">
                  ${clonedElements[1].innerHTML}
                </div>
              </div>
              <div class="flex items-center">
                <div>
                  ${clonedElements[2].innerHTML}
                </div>
                <div class="pr-6">
                  ${clonedElements[3].innerHTML}
                </div>
              </div>
            </div>
          `;
          container.innerHTML = htmlContent;

          //@ts-ignore
          bodyRef.current.querySelector("section:first-of-type").innerHTML =
            htmlContent;
        }, 0);
        setLoading(false);
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };
    fetchData();
  });

  const contentHtml = () => {
    if (loading) {
      return <p>{t("Loading")}...</p>;
    }

    if (error) {
      //@ts-ignore
      return <p>Error: {error.message}</p>;
    }

    if (data) {
      return <div dangerouslySetInnerHTML={{ __html: data }} />;
    }

    return "";
  };

  return (
    <>
      {showModal ? (
        <>
          <div
            id="cardDetailsModal"
            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
          >
            <div className="relative my-6 max-w-2xl w-full overflow-y-auto h-2/3 mx-2">
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/*header*/}
                <div className="sticky top-0 z-10 bg-white flex items-start justify-between py-3 px-5 border-b border-solid border-slate-200 rounded-t">
                  <h3
                    className="text-3xl font-semibold"
                    dangerouslySetInnerHTML={{ __html: t(title) }}
                  />
                  <button
                    className="flex items-center bg-transparent border-0 text-black opacity-50 font-semibold outline-none focus:outline-none"
                    onClick={onClose}
                  >
                    <span className="bg-transparent text-black h-6 w-6 text-4xl block outline-none focus:outline-none">
                      ×
                    </span>
                  </button>
                </div>
                {/*body*/}
                <div
                  className="relative p-6 flex-auto prose prose-table:text-right mx-auto"
                  ref={bodyRef}
                >
                  {contentHtml()}
                </div>
                {/*footer*/}
                <div className="sticky bottom-0 z-10 bg-white flex items-center justify-between p-3 border-t border-solid border-slate-200 rounded-b">
                  <div
                    dangerouslySetInnerHTML={{ __html: t("ModalMarketing") }}
                  ></div>
                  <button
                    className="background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none ease-linear transition-all duration-150"
                    type="button"
                    onClick={onClose}
                  >
                    {t("Close")}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
};

export default Modal;
